import { Component, Input, ViewEncapsulation } from '@angular/core';
import { BusinessSummaryResponseDTO } from 'src/app/shared/models/dtos/responses/business-summary-response-dto/business-summary-response-dto';

@Component({
  selector: 'app-photo-name',
  templateUrl: './photo-name.component.html',
  styleUrls: ['./photo-name.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

/**
 * Shows basic infos about a business
 */
export class PhotoNameComponent {
  @Input() businessSummary?: BusinessSummaryResponseDTO;
  @Input() businessDisabled!: boolean;
  businessNameLength!: number;
  businessStatus: string = '';

  /**
   * Checks if business name length is too big
   * @return {boolean}
   */
  maxNameLength(): boolean {
    const maxLength = 18;
    if (!this.businessSummary) {
      return false;
    }
    return this.businessSummary.name!.length >= maxLength ? true : false;
  }
}
